import { useState } from 'react'

export interface DoorConfig {
  panelHeight: number    // Отступ снизу (высота панели)
  visibleEdge: number    // Сколько видно в открытом состоянии
  doorWidth: number      // Ширина каждой двери в %
}

interface DoorEditorProps {
  config: DoorConfig
  onChange: (config: DoorConfig) => void
}

export const defaultDoorConfig: DoorConfig = {
  panelHeight: 184,
  visibleEdge: 35,
  doorWidth: 50,
}

export default function DoorEditor({ config, onChange }: DoorEditorProps) {
  const [isOpen, setIsOpen] = useState(false)

  const updateConfig = (field: keyof DoorConfig, value: number) => {
    onChange({
      ...config,
      [field]: value,
    })
  }

  const exportConfig = () => {
    const json = JSON.stringify(config, null, 2)
    // Config copied to clipboard
    navigator.clipboard.writeText(json)
    alert('Конфиг скопирован в буфер обмена!')
  }

  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="fixed top-4 right-4 z-50 bg-purple-600 text-white px-3 py-2 rounded-lg text-sm font-bold shadow-lg"
      >
        🚪 Настройки
      </button>
    )
  }

  return (
    <div className="fixed top-4 right-4 z-50 bg-gray-900/95 text-white p-4 rounded-xl shadow-2xl w-[280px]">
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-bold text-lg">🚪 Настройки дверей</h3>
        <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white text-xl">✕</button>
      </div>

      {/* Отступ снизу (panelHeight) */}
      <div className="mb-4">
        <label className="text-xs text-gray-400 block mb-1">
          Отступ снизу (↑↓): {config.panelHeight}px
        </label>
        <input
          type="range"
          min="150"
          max="400"
          value={config.panelHeight}
          onChange={(e) => updateConfig('panelHeight', Number(e.target.value))}
          className="w-full"
        />
        <div className="flex gap-2 mt-1">
          <button
            onClick={() => updateConfig('panelHeight', config.panelHeight - 10)}
            className="flex-1 bg-gray-700 hover:bg-gray-600 py-1 rounded text-sm"
          >
            -10
          </button>
          <button
            onClick={() => updateConfig('panelHeight', config.panelHeight + 10)}
            className="flex-1 bg-gray-700 hover:bg-gray-600 py-1 rounded text-sm"
          >
            +10
          </button>
        </div>
      </div>

      {/* Видимый край */}
      <div className="mb-4">
        <label className="text-xs text-gray-400 block mb-1">
          Видимый край (открыто): {config.visibleEdge}px
        </label>
        <input
          type="range"
          min="0"
          max="100"
          value={config.visibleEdge}
          onChange={(e) => updateConfig('visibleEdge', Number(e.target.value))}
          className="w-full"
        />
      </div>

      {/* Ширина двери */}
      <div className="mb-4">
        <label className="text-xs text-gray-400 block mb-1">
          Ширина каждой двери: {config.doorWidth}%
        </label>
        <input
          type="range"
          min="40"
          max="60"
          value={config.doorWidth}
          onChange={(e) => updateConfig('doorWidth', Number(e.target.value))}
          className="w-full"
        />
      </div>

      {/* Кнопки */}
      <div className="flex gap-2">
        <button
          onClick={exportConfig}
          className="flex-1 bg-green-600 hover:bg-green-500 px-3 py-2 rounded font-bold text-sm"
        >
          📋 Экспорт
        </button>
        <button
          onClick={() => onChange(defaultDoorConfig)}
          className="flex-1 bg-gray-600 hover:bg-gray-500 px-3 py-2 rounded font-bold text-sm"
        >
          🔄 Сброс
        </button>
      </div>
    </div>
  )
}

